import {combineReducers} from "redux";

// import reducers
import auth from "./auth";
import utils from "./utils";
import languages from "./languages";
import users from "./users";
import reviews from "./reviews";
import moderators from "./moderators";
import staticTexts from "./staticTexts";
import media from "./media";
import composite from "./composite";
import filter from "./filter";
import category from "./category";
import product from "./product";
import order from "./order";
import slider from "./slider";
import badges from "./badges";
import status from "./status";
import partner from "./partner";
import banner from "./banner";
import section from "./section";
import promoCode from "./promoCodes";
import bonusCards from "./bonusCards";
import history from "./history";
import customPages from "./customPages";
import attributes from "./attributes";
import market from "./market";
import general from "./general";
import project from "./project";
import about from "./about";
import blogTypes from "./blogTypes";
import blogs from "./blogs";
import subscribers from "./subscribers";
import advertising from "./advertising";
import notifications from "./notifications";
import brandTypes from "./brandTypes";
import brand from "./brand";


export default combineReducers({
    about,
    auth,
    utils,
    languages,
    users,
    media,
    composite,
    reviews,
    moderators,
    staticTexts,
    filter,
    category,
    product,
    order,
    slider,
    badges,
    status,
    partner,
    banner,
    section,
    promoCode,
    bonusCards,
    history,
    customPages,
    attributes,
    market,
    general,
    project,
    blogTypes,
    blogs,
    subscribers,
    advertising,
    notifications,
    brandTypes,
    brand
});
